import {
  getParentPath,
  transformSelectedTreeLevel
} from 'domains/IngredientsTree/helpers'

import { INGREDIENTS_TREE_RDB } from '__constants__'
import PropTypes from 'prop-types'

/**
 * Selects a node in the ingredients tree.
 *
 * @param {Object} node - The node to be selected.
 * @param {Object} selectedNode - The currently selected node.
 * @param {Object} ingredientsTree - The ingredients tree.
 * @param {Array} currentTreeLevel - The current tree level.
 * @param {Function} dispatch - The dispatch function.
 * @returns {void}
 */
const selectNode = (
  node,
  selectedNode,
  ingredientsTree,
  currentTreeLevel,
  dispatch
) => {
  if (node?._id === selectedNode?._id) {
    const parentPath = getParentPath(node?._path)
    const result = transformSelectedTreeLevel(
      ingredientsTree,
      parentPath ?? INGREDIENTS_TREE_RDB
    )

    const parents = result.filter((el) => el?._path === parentPath)

    dispatch({ type: 'SET_SELECTED_NODE', payload: parents?.[0] })
    dispatch({ type: 'SET_CURRENT_TREE_LEVEL', payload: result })
  } else if (
    currentTreeLevel.filter((el) => el?._path === node?._path).length
  ) {
    dispatch({ type: 'SET_SELECTED_NODE', payload: node })
  } else {
    dispatch({ type: 'SET_SELECTED_NODE', payload: node })

    const result = transformSelectedTreeLevel(ingredientsTree, node?._path)
    dispatch({ type: 'SET_CURRENT_TREE_LEVEL', payload: result })
  }
}

selectNode.propTypes = {
  node: PropTypes.object,
  selectedNode: PropTypes.object,
  ingredientsTree: PropTypes.object,
  currentTreeLevel: PropTypes.array,
  dispatch: PropTypes.func
}

export default selectNode
